import {Column, Entity, PrimaryGeneratedColumn} from "typeorm";

@Entity()
export class ActionNotification {

	@PrimaryGeneratedColumn({ name:"id" })
	id?: number;

	@Column({ nullable: true }) 
	iccid?: string;

	@Column({ nullable: true }) 
	customer?: string;

	@Column({ nullable: true, type: "bigint" })
	tariff?: number;

	@Column()
	provider!: string;

	@Column()
	notificationType!: string;

	@Column()
	notificationDetails!: string;

	@Column('datetime')
	timestamp!: Date;

}